import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddInsulatedPageNew from "../../components/Insulated/AddInsulatedPageNew";



const AddInsulatedPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Insulated" link2="/insulated" title="Add Insulated" />

        {/* AddUserLayer */}
        <AddInsulatedPageNew />


      </MasterLayout>
    </>
  );
};

export default AddInsulatedPage;
